import { get, post, getDownload } from 'utils/api';

export default class RdBudgetFormService {
  async upsertRdBudgetForm(data) {
    return await post('/rd-budget-form', JSON.stringify(data));
  }

  async getRdBudgetForm(rentForecastId) {
    return await get(`/rd-budget-form/${rentForecastId}`);
  }

  async generateRdBudgetReport(
    organizationId,
    propertyId,
    rentForecastId,
    budgetType,
    parameters,
    source,
    fileName = null,
  ) {
    const report = await post(
      `/${organizationId}/${propertyId}/rd-budget-form/${rentForecastId}/generate-report`,
      JSON.stringify({
        budgetType,
        source,
        ...(parameters ? { parameters } : {}),
      }),
    );

    if (report.id) {
      await getDownload(
        `/${organizationId}/${propertyId}/rd-budget-form/${rentForecastId}/download-report/${report.id}`,
        fileName ? `${fileName}.pdf` : 'report.pdf',
      );
      await getDownload(
        `/${organizationId}/${propertyId}/rd-budget-form/${rentForecastId}/download-report/${report.id}?fileType=xml`,
        fileName ? `${fileName}.xml` : 'report.xml',
      );
    }
  }

  approveBudget(
    organizationId: string,
    propertyId: string,
    rentForecastId: string,
  ): Promise<any> {
    return post(
      `/${organizationId}/${propertyId}/rd-budget-form/${rentForecastId}/approve-budget`,
    );
  }

  createWizardRentForecast(
    organizationId: string,
    propertyId: string,
    rentForecastId: string,
    data: Object,
  ): Promise<any> {
    return post(
      `/${organizationId}/${propertyId}/rent-forecast/${rentForecastId}/wizard-copy`,
      JSON.stringify(data),
    );
  }

  async createOrUpdateSignature(
    organizationId,
    propertyId,
    rentForecastId,
    data,
  ) {
    return post(
      `/${organizationId}/${propertyId}/rd-budget-form/${rentForecastId}/authorize-signature`,
      JSON.stringify(data),
    );
  }

  async getSignature(organizationId, propertyId, rentForecastId) {
    return get(
      `/${organizationId}/${propertyId}/rd-budget-form/${rentForecastId}/authorize-signature`,
    );
  }

  getAllReports(
    organizationId: string,
    propertyId: string,
    rentForecastId: string,
  ): Promise<Array<any>> {
    return get(
      `/${organizationId}/${propertyId}/rd-budget-form/${rentForecastId}/report-history`,
    );
  }
}
